// extracted by mini-css-extract-plugin
module.exports = {"boxesContainer":"HomepageBody_boxesContainer__2KX2D","homeText":"HomepageBody_homeText__1x5PP"};